import type { FC, ReactNode } from 'react';
import styles from './styles.module.scss';

type SectionProps = {
	children: ReactNode;
	/** Opt-in white surface instead of the default grey. */
	white?: boolean;
	/** Opt-in 24px padding instead of the default 16px. */
	spacious?: boolean;
};

const Section: FC<SectionProps> = ({ children, white = false, spacious = false }) => {
	const className = [
		styles.section,
		white && styles.white,
		spacious && styles.spacious,
	]
		.filter(Boolean)
		.join(' ');

	return <section className={className}>{children}</section>;
};

export default Section;
